/* global Lang */
import React from 'react';
import Card, {
  CardBody, CardTitle, CardSubtitle, CardText,
} from '../Card';
import ObjectTranslation from '../ObjectTranslation';

export default ({ totalProfessions, professions, levels }) => (
  <>
    <h3 className="bg-body">
      {Lang.get('messages.dashboard.inventory.myProfessions')}
      {` (${professions.length}/${totalProfessions})`}
    </h3>
    <div className="row">
      {professions.map(({ data: { slug, translations, level } }) => (
        <div key={slug} className="col-6 col-md-4 col-lg-3 mb-4">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="mb-1">
                <ObjectTranslation index="title" object={translations} />
              </CardTitle>
              <CardSubtitle className="mb-2">
                {(levels.find(fullLevel => level.id === fullLevel.id) || {}).title}
              </CardSubtitle>
              <CardText>
                <ObjectTranslation index="description" object={translations} />
              </CardText>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  </>
);
